module.exports = __webpack_public_path__ + "static/video-poster-da3f5a85aa3ac52af9b8fb842040ad10.webp";